import feedbackIcon from '@/assets/images/feedback-icon.webp';
import { Button } from '@/components/common/button';
import { ResultDialog } from '@/components/feedback/result-dialog';
import { useToast } from '@/components/feedback/toast';

export type FeedbackPromptProps = {
  open: boolean;
  onClose: () => void;
};

/**
 * "We'd Love Your Feedback" prompt (Figma 2249-686760). Shown from the device-detail
 * "Provide Feedback" action and after a support ticket is raised. "Maybe Later" dismisses;
 * "Sure" acknowledges (there is no feedback form in scope — a thank-you toast stands in).
 */
export function FeedbackPrompt({ open, onClose }: FeedbackPromptProps) {
  const toast = useToast();
  return (
    <ResultDialog
      open={open}
      icon={feedbackIcon}
      title="We'd Love Your Feedback"
      subtitle="Got a few minutes? Tell us about your experience and help us serve you better."
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            Maybe Later
          </Button>
          <Button
            variant="neutral"
            onClick={() => {
              toast.success({ title: 'Thanks for your feedback!' });
              onClose();
            }}
          >
            Sure
          </Button>
        </>
      }
      onClose={onClose}
    />
  );
}
